import common from './common';
import customer from './customer';

export default {
    common,
    customer,
};
